import { render, staticRenderFns } from "./DomainInfo.vue?vue&type=template&id=08205ac2&"
import script from "./DomainInfo.vue?vue&type=script&lang=js&"
export * from "./DomainInfo.vue?vue&type=script&lang=js&"
import style0 from "./DomainInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08205ac2')) {
      api.createRecord('08205ac2', component.options)
    } else {
      api.reload('08205ac2', component.options)
    }
    module.hot.accept("./DomainInfo.vue?vue&type=template&id=08205ac2&", function () {
      api.rerender('08205ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/DomainInfo.vue"
export default component.exports